import { Component, HostBinding, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'suka-layout-section',
  template: `
    <div *ngIf="annotated else elseTpl" class="annotation__wrapper">
      <div class="annotation">
        <h5>{{title}}</h5>
        <p>{{description}}</p>
      </div>
      <div class="annotation-content">
        <ng-content *ngTemplateOutlet="elseTpl"></ng-content>
      </div>
    </div>

    <ng-template #elseTpl>
      <ng-content></ng-content>
    </ng-template>
  `
})
export class LayoutSection {
  @HostBinding('class.layout__section') baseClass = true;

  @HostBinding('class.layout__section--secondary') @Input() secondary = false;
  @HostBinding('class.layout__section--one-half') @Input() oneHalf = false;
  @HostBinding('class.layout__section--one-third') @Input() oneThird = false;
  @HostBinding('class.layout__section--annotated') @Input() annotated = false;

  @Input() title: string | TemplateRef<any>;
  @Input() description: string | TemplateRef<any>;
}
